module.exports = __webpack_public_path__ + "static/media/bakvodvar_rodur.ab75a961.png";